import React, { memo } from 'react'
import PropTypes from 'prop-types'

const TableTitle = ({ title }) => {
    return (
        <div className={'table__title'}>
            <p className={'heading-secondary'}>{title}</p>
        </div>
    )
}

TableTitle.propTypes = {
    title: PropTypes.string,
}

export default memo(TableTitle)
